import { Layout } from "../../layouts/authLayout/Layout.js";
import Login from "../../components/auth/Login.js";
 const SingInPage = () => {
  return (
    <Layout>
      <Login/>
    </Layout>
  )
}
export default SingInPage